import { atom } from 'jotai';

export const currentMenuNumAtom = atom<number>(1);
